import * as React from 'react';
import { JSX } from 'react/jsx-runtime';

const BallIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1107 9.18792L10.6667 8.79059V5.33325C10.6667 4.62601 10.3857 3.94773 9.88562 3.44763C9.38552 2.94754 8.70725 2.66659 8 2.66659C7.29276 2.66659 6.61448 2.94754 6.11439 3.44763C5.61429 3.94773 5.33334 4.62601 5.33334 5.33325V8.79059L4.88934 9.18792C4.24503 9.76289 3.77325 10.5057 3.52667 11.3333H12.4733C12.2268 10.5057 11.755 9.76289 11.1107 9.18792ZM10 12.6666C10 13.197 9.78929 13.7057 9.41422 14.0808C9.03914 14.4559 8.53044 14.6666 8 14.6666C7.46957 14.6666 6.96086 14.4559 6.58579 14.0808C6.21072 13.7057 6 13.197 6 12.6666H2C1.9991 11.8223 2.17683 10.9873 2.52152 10.2166C2.86622 9.44586 3.37008 8.75677 4 8.19459V5.33325C4 4.27239 4.42143 3.25497 5.17158 2.50482C5.92172 1.75468 6.93914 1.33325 8 1.33325C9.06087 1.33325 10.0783 1.75468 10.8284 2.50482C11.5786 3.25497 12 4.27239 12 5.33325V8.19459C12.6299 8.75677 13.1338 9.44586 13.4785 10.2166C13.8232 10.9873 14.0009 11.8223 14 12.6666H10ZM8 13.3333C8.17681 13.3333 8.34638 13.263 8.47141 13.138C8.59643 13.013 8.66667 12.8434 8.66667 12.6666H7.33334C7.33334 12.8434 7.40357 13.013 7.5286 13.138C7.65362 13.263 7.82319 13.3333 8 13.3333Z"
      fill="#004E9B"
    />
    <circle
      cx="3.2"
      cy="3.2"
      r="3.2"
      transform="matrix(-1 0 0 1 14.9333 0)"
      fill="#FF5E5E"
    />
  </svg>
);

export default BallIcon;
